var map = {
	"./channel_a/Bidding Agency@2x.png": 5828,
	"./channel_a/ad 2.png": 967,
	"./channel_a/ad.png": 997,
	"./channel_a/banner.jpg": 4764,
	"./channel_a/bidder@2x.png": 1484,
	"./channel_a/expert@2x.png": 4398,
	"./channel_a/logo.png": 7947,
	"./channel_a/role_bg@2x.png": 6942,
	"./channel_a/tenderer@2x.png": 1479,
	"./channel_b/Bidding Agency@2x.png": 5187,
	"./channel_b/adLogo.png": 7997,
	"./channel_b/adLogo1.png": 3968,
	"./channel_b/banner.png": 4065,
	"./channel_b/expert@2x.png": 1237,
	"./channel_b/logo.png": 9422,
	"./channel_b/logo2.png": 3262,
	"./channel_b/role_bg@2x.png": 4299,
	"./channel_b/tenderer@2x.png": 748,
	"./channel_c/Bidding Agency@2x.png": 5830,
	"./channel_c/Notice.png": 3844,
	"./channel_c/banner.png": 7834,
	"./channel_c/banner_改版.png": 2316,
	"./channel_c/bidder@2x.png": 62,
	"./channel_c/customer service.png": 2829,
	"./channel_c/expand.png": 4788,
	"./channel_c/expert@2x.png": 324,
	"./channel_c/home@2x.png": 9527,
	"./channel_c/lgin_bg@2x.jpg": 7830,
	"./channel_c/lgin_picture@2x.jpg": 4535,
	"./channel_c/logo.png": 6009,
	"./channel_c/logo2(1).png": 5709,
	"./channel_c/logo2(2).png": 7088,
	"./channel_c/logo2.png": 8511,
	"./channel_c/logo2@2x.png": 8273,
	"./channel_c/logo3.png": 9766,
	"./channel_c/more.png": 4663,
	"./channel_c/positioning.png": 821,
	"./channel_c/role_bg@2x.png": 4400,
	"./channel_c/search.png": 4492,
	"./channel_c/telephone.png": 1586,
	"./channel_c/tenderer@2x.png": 6349,
	"./channel_c/weixin.jpg": 4870,
	"./channel_c/zhuanjia.jpg": 9562,
	"./channel_d/adLogo.png": 7595,
	"./channel_d/adPageTextImg.png": 8637,
	"./channel_d/banner.jpg": 547,
	"./channel_d/header_bg.jpg": 2546,
	"./channel_d/logo.png": 3036,
	"./new_slices/Bidding Agency@2x.png": 1683,
	"./new_slices/Notice.png": 751,
	"./new_slices/banner.png": 9009,
	"./new_slices/banner_改版.png": 805,
	"./new_slices/bidder@2x.png": 2547,
	"./new_slices/customer service.png": 4290,
	"./new_slices/expand.png": 5059,
	"./new_slices/expert@2x.png": 7957,
	"./new_slices/home@2x.png": 9390,
	"./new_slices/lgin_bg@2x.jpg": 221,
	"./new_slices/lgin_picture@2x.jpg": 4346,
	"./new_slices/logo.png": 6110,
	"./new_slices/logo2(1).png": 3174,
	"./new_slices/logo2(2).png": 8855,
	"./new_slices/logo2.png": 4158,
	"./new_slices/logo2@2x.png": 6358,
	"./new_slices/logo3.png": 7303,
	"./new_slices/more.png": 3432,
	"./new_slices/positioning.png": 3228,
	"./new_slices/role_bg@2x.png": 6539,
	"./new_slices/search.png": 2279,
	"./new_slices/telephone.png": 1439,
	"./new_slices/tenderer@2x.png": 4156,
	"./new_slices/weixin.jpg": 6957,
	"./new_slices/zhuanjia.jpg": 5021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3747;